import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  ROUTE_PATH,
} from "../../../app/constants";
import { Header, Button, ErrorMark } from "../../../components/RegularComponents";
import CheckboxForm from "../../../components/CheckBoxForm";
import TopNavigationBar from "../../TopNavigationBar";
import { ERROR_STRING } from "../../../app/errors";
import { setCurrentAgentMortgageProperty } from "../../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import {applicationTypeFromLicenceSubType} from '../../../redux/slice/applicationsUtils';
import { usePathApplication } from "../../../redux/hooks/usePathApplication";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { setMortgageProperty } from "../../../redux/slice/primaryAgencyApplicationSlice";

const MORTGAGE_APPLICATION_PROPERTY = "confirmCompletionRegulatoryInfo";

export const MainAgentConfirmCompletionRegulatoryInfo = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();
  const { application } = usePathApplication();
  // const isPrincipalBroker =  (ROUTE_PATH.PB_APP.search(application) !== -1);
  
  const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
  const licencingSubType = agencyApplication?.licencingSubType;

  const applicationMode = APPLICATION_MODE_NEW;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);

  const [confirmCheck, setConfirmCheck] = useState(false);
  const [saveApplicationError, setSaveApplicationError] = useState(false);
  const [showValidationError, setShowValidationError] = useState(false);

  const handleNext = () => {

    if (!confirmCheck) {
      setShowValidationError(true);
      return;
    }

    setShowValidationError(false);

    // Set MORTGAGE PROP value
    dispatch(
      setMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: true,
      })
    );

    dispatch(
      saveBusinessLicenceApplicationData(applicationType, applicationMode)
    )
      .then((data) => {
        // On to the next item
        dispatch(push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CRIMINAL_RECORD_DOCUMENT_UPLOAD}`));
      })
      .catch((err) => {
        setSaveApplicationError(true);
      });
  };

  const handleModalClose = () => {
    // Set MORTGAGE PROP value
    dispatch(
      setCurrentAgentMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: confirmCheck,
      })
    );

    onEditSave();
  };

  const text = "I confirm that I completed the regulatory information program";

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                  style={{ paddingBottom: "30px" }}
                  id="complete-mortgage-education-header"
                  header="Confirm completion of the regulatory information program"
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <CheckboxForm
              id="confirm-before-start-checkbox"
              checked={confirmCheck}
              value={confirmCheck}
              labelText={text}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck(val);
              }}
            />
          </div>
        </div>

        <div className="row">
          <div
            className={
              "col-lg-4" +
              (saveApplicationError || showValidationError ? " has-error" : "")
            }
          >
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={!isModal ? handleNext : handleModalClose}
            />
            {(saveApplicationError || showValidationError) && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CONFIRM_MORTGAGE_EDUCATION_REQUIREMENT}
              </div>
            )}
            {saveApplicationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
